import { Flex, Image, Tab, TabList, Text } from "@chakra-ui/core";
import React from "react";
import Eligibility from "../../../../../static/assets/icons/Profile/Eligibility.png";
import OtherDetails from "../../../../../static/assets/icons/Profile/Other Details.png";
import PersonalInfo from "../../../../../static/assets/icons/Profile/Personal Info.png";
import ProfessionalInfo from "../../../../../static/assets/icons/Profile/Professional Info.png";
import Resume from "../../../../../static/assets/icons/Profile/Resume.png";
import Skills from "../../../../../static/assets/icons/Profile/Skills.png";
import "./style.scss";

const IconsData = [
  {
    title: "Resume",
    icon: Resume,
    tag: "resume",
  },
  {
    title: "Personal Info",
    icon: PersonalInfo,
    tag: "personalInfo",
  },
  {
    title: "Skills",
    icon: Skills,
    tag: "skills",
  },
  {
    title: "Professional Info",
    icon: ProfessionalInfo,
    tag: "professionalInfo",
  },
  {
    title: "Eligibility",
    icon: Eligibility,
    tag: "eligibility",
  },
  {
    title: "Other Details",
    icon: OtherDetails,
    tag: "otherDetails",
  },
];

function SubNavBar() {
  return (
    <TabList
      backgroundColor="#293c43"
      marginTop="65px"
      className="tab-bar"
      align="center"
      justifyContent="space-around"
    >
      {IconsData.map((each) => (
        <Tab key={each.title}>
          <Flex direction="column" align="center" padding="5">
            <Image src={each.icon} />
            <Text color="#eeeeee">{each.title}</Text>
          </Flex>
        </Tab>
      ))}
    </TabList>
  );
}

export default SubNavBar;
